import { inLifePaths } from '@in-life/paths';
import { clearInLifeOrderAndRedirectToMyAccount } from '@in-life/utils/clearInLifeOrder';
import {
  BreadcrumbItem,
  Breadcrumbs,
  Flex,
} from '@utilitywarehouse/hearth-react';
import { useLocation } from 'react-router-dom';

import { DialogID, useDialog } from '@components/Dialog';
import { stripTrailingSlash } from '@utils/routing/stripTrailingSlash';

import './styles.scss';

type InLifeBreadcrumbsProps = {
  variant?: 'default' | 'white';
};

const InLifeBreadcrumbs = ({ variant = 'default' }: InLifeBreadcrumbsProps) => {
  const { pathname } = useLocation();
  const currentPath = stripTrailingSlash(pathname);
  const dialog = useDialog(DialogID.IN_LIFE_EXIT);

  const goDirectlyToMyAccount = [inLifePaths.thankYou];

  const handleOnClickHome = () => {
    if (goDirectlyToMyAccount.includes(currentPath)) {
      clearInLifeOrderAndRedirectToMyAccount();
    } else {
      dialog.setOpen(true);
    }
  };

  return (
    <Flex
      className={`inlife-breadcrumbs inlife-breadcrumbs__${variant}`}
      data-testid="inlife-breadcrumbs"
    >
      <Breadcrumbs>
        <BreadcrumbItem
          data-testid="inlife-breadcrumb-home-link"
          onClick={handleOnClickHome}
        >
          Home
        </BreadcrumbItem>
        <BreadcrumbItem href="#" currentPage>
          Energy
        </BreadcrumbItem>
      </Breadcrumbs>
    </Flex>
  );
};

export { InLifeBreadcrumbs };
